app.directive('checkoutShoplinePayment', [
  '$filter',
  function ($filter) {
    const SPECIFIC_CREDIT_TYPE = {
      CARD_PREFIX: 'card_prefix',
      CARD_SCHEME: 'card_scheme',
    };

    const SCHEME_MAP = {
      Visa: 'visa',
      Mastercard: 'master',
      'American Express': 'american_express',
    };

    const ERROR_TYPE = {
      UNKNONW_SCHEME: 'unknow_scheme',
    };

    function isValidCardPrefix(config, data) {
      const { card_prefix_list: list } = config;
      const { bin } = data;
      return list.some((prefix) => bin.startsWith(prefix));
    }

    function isValidCardScheme(config, data) {
      const { card_scheme_list: list } = config;

      const { scheme = '' } = data;
      if (!scheme) {
        return new Error(ERROR_TYPE.UNKNONW_SCHEME);
      }

      return list.includes(
        SCHEME_MAP[scheme] || scheme.toLowerCase().replaceAll(' ', '_'),
      );
    }

    function isValidCardData(payment, data) {
      if (!(payment.config_data && payment.config_data.whitelist_validation)) {
        return true;
      }

      const validationConfig = payment.config_data.whitelist_validation;
      const { type } = validationConfig;
      switch (type) {
        case SPECIFIC_CREDIT_TYPE.CARD_PREFIX:
          return isValidCardPrefix(validationConfig, data);
        case SPECIFIC_CREDIT_TYPE.CARD_SCHEME:
          return isValidCardScheme(validationConfig, data);
        default:
          return false;
      }
    }

    return {
      restrict: 'A',
      scope: '=',
      link: function (scope) {
        return $.getScript(
          'https://cdn.checkout.com/js/framesv2.min.js',
          function () {
            var form = document.getElementById('payment-form');
            var iconRoute =
              'https://s3-ap-southeast-1.amazonaws.com/static.shoplineapp.com/web/assets/checkout_payment/';
            var cardInfoError = form.getAttribute('card-info-error');
            var inputError = form.getAttribute('input-error');
            var init = true;
            Frames.init({
              publicKey: form.getAttribute('public-key'),
              localization: {
                cardNumberPlaceholder: form.getAttribute('card-number-text'),
                cvvPlaceholder: form.getAttribute('cvc-text'),
                expiryMonthPlaceholder: 'MM',
                expiryYearPlaceholder: 'YY',
              },
            });
            var logos = {
              'card-name': {
                src: 'card-name',
                alt: 'card name log',
              },
              'card-number': {
                src: 'card',
                alt: 'card number logo',
              },
              'expiry-date': {
                src: 'exp-date',
                alt: 'expiry date logo',
              },
              cvv: {
                src: 'cvv',
                alt: 'cvv logo',
              },
            };
            Frames.addEventHandler(
              Frames.Events.FRAME_VALIDATION_CHANGED,
              onValidationChanged,
            );
            function onValidationChanged(event) {
              var e = event.element;
              if (event.isValid || event.isEmpty) {
                if (e === 'card-number' && !event.isEmpty) {
                  showPaymentMethodIcon();
                }
                setDefaultIcon(e);
                clearError(e);
              } else {
                if (e === 'card-number') {
                  clearPaymentMethodIcon();
                }
                setDefaultErrorIcon(e);
                setErrorMessage(e);
                init = false;
              }
            }
            function clearError(el) {
              var selector = '.error-message__' + el;
              var message = document.querySelector(selector);
              var inputContainer = document.querySelector(
                '.' + el + '-container .input-container',
              );
              message.textContent = '';
              inputContainer && inputContainer.classList.remove('error');
            }
            function showPaymentMethodIcon(parent, paymentMethod) {
              if (parent) parent.classList.add('show');
              var logo = document.getElementById('logo-payment-method');
              if (paymentMethod) {
                var name = paymentMethod.toLowerCase();
                logo.setAttribute('src', iconRoute + name + '.svg');
                logo.setAttribute('alt', paymentMethod || 'payment method');
              }
              logo.style.removeProperty('display');
            }
            function clearPaymentMethodIcon(parent) {
              if (parent) parent.classList.remove('show');
              var logo = document.getElementById('logo-payment-method');
              logo.style.setProperty('display', 'none');
            }
            function setErrorMessage(el) {
              var selector = '.error-message__' + el;
              var message = document.querySelector(selector);
              var inputContainer = document.querySelector(
                '.' + el + '-container .input-container',
              );
              message.textContent = errorText(el);
              inputContainer.classList.add('error');
            }
            function setDefaultIcon(el) {
              var selector = 'icon-' + el;
              var logo = document.getElementById(selector);
              logo.setAttribute('src', iconRoute + logos[el].src + '.svg');
              logo.setAttribute('alt', logos[el].alt);
            }
            function setDefaultErrorIcon(el) {
              var selector = 'icon-' + el;
              var logo = document.getElementById(selector);
              logo.setAttribute(
                'src',
                iconRoute + logos[el].src + '-error.svg',
              );
              logo.setAttribute('alt', logos[el].alt);
            }
            Frames.addEventHandler(
              Frames.Events.CARD_VALIDATION_CHANGED,
              cardValidationChanged,
            );
            function cardValidationChanged(event) {
              if (!init) {
                Object.keys(event.isElementValid).forEach(function (element) {
                  var elementName = element;
                  if (element === 'cardNumber') {
                    elementName = 'card-number';
                  } else if (element === 'expiryDate') {
                    elementName = 'expiry-date';
                  }
                  if (event.isElementValid[element]) {
                    setDefaultIcon(elementName);
                    clearError(elementName);
                  } else {
                    setDefaultErrorIcon(elementName);
                    setErrorMessage(elementName);
                  }
                });
              }
            }
            Frames.addEventHandler(
              Frames.Events.CARD_TOKENIZATION_FAILED,
              onCardTokenizationFailed,
            );
            function onCardTokenizationFailed() {
              scope.errors.checkout = cardInfoError;
              scope.renderErrors();
            }
            Frames.addEventHandler(
              Frames.Events.CARD_TOKENIZED,
              onCardTokenized,
            );
            function onCardTokenized(event) {
              var result = isValidCardData(scope.payment, event);
              if (result === true) {
                scope.cardData = event;
                scope.handleShoplinePaymentCheckout();
              } else {
                var messageKey = 'form.validation.card.bin.error';
                if (typeof result === 'object') {
                  messageKey += '.' + result.message;
                }

                scope.errors.cardValidation = $filter('translate')(messageKey);
                scope.renderErrors();
                scope.btnPlaceOrder.stop();
                scope.state.isCheckoutLoading = false;
                Frames.enableSubmitForm();
              }
            }
            Frames.addEventHandler(
              Frames.Events.PAYMENT_METHOD_CHANGED,
              paymentMethodChanged,
            );
            function paymentMethodChanged(event) {
              var paymentMethod = event.paymentMethod;
              var container = document.querySelector(
                '.icon-container.payment-method',
              );
              if (!paymentMethod) {
                clearPaymentMethodIcon(container);
              } else {
                showPaymentMethodIcon(container, paymentMethod);
              }
            }

            scope.$on('cardholdername.invalid', function () {
              setErrorMessage('card-name');
              setDefaultErrorIcon('card-name');
            });

            var cardHolderName = document.querySelector(
              '.card-name-container #cardholdersname',
            );
            cardHolderName.addEventListener('input', resetCardHolderField);
            function resetCardHolderField() {
              var regex = /[0-9]+/;
              if (regex.test(this.value) == true) {
                this.value = this.value.replace(/[0-9]/g, '');
              }

              if (this.value == '') {
                setErrorMessage('card-name');
                setDefaultErrorIcon('card-name');
              } else {
                setDefaultIcon('card-name');
                clearError('card-name');
              }
            }

            var errorText = function (el) {
              if (el === 'card-name') {
                var fieldName = document.querySelector(
                  '.card-name-container .title-text',
                );
                return $filter('translate')('form.validation.required', {
                  field_name: fieldName.textContent,
                });
              } else {
                return inputError;
              }
            };
          },
        );
      },
    };
  },
]);
